import request from '@/utils/request'
export function getSecondTitList(params) {
  return request({
    url: '/mall/ordermanage/platformdoc/getSecondTitList',
    method: 'post',
    params
  })
}

export function getThirdTitList(params) {
  return request({
    url: '/mall/ordermanage/platformdoc/getThirdTitList',
    method: 'post',
    params
  })
}

export function getDocContent(params) {
  return request({
    url: '/mall/ordermanage/platformdoc/getDocContent',
    method: 'post',
    params
  })
}

export function getContentComment(params) {
  return request({
    url: '/mall/ordermanage/platformdoc/getContentComment',
    method: 'post',
    params
  })
}

export function contentComment(data) {
  return request({
    url: '/mall/ordermanage/platformdoc/contentComment',
    method: 'post',
    data
  })
}
// export function queryArea(params) {
//     return request({
//       url: '/mall/ordermanage/useraddress/queryArea',
//       method: 'post',
//       params
//     })
//   }
